var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"banner mt-10 mb-16"},[_c('v-col',{staticClass:"welcome-text-container",attrs:{"cols":"7"}},[_c('h2',[_vm._v("Welcome to InformedGENOMICS™")]),_c('p',[_vm._v(" The most comprehensive and up-to-date GENOMICS policy guidance—at your fingertips ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }